import { render, staticRenderFns } from "./Tietie.vue?vue&type=template&id=6585c2ea&scoped=true&"
import script from "./Tietie.vue?vue&type=script&lang=js&"
export * from "./Tietie.vue?vue&type=script&lang=js&"
import style0 from "./Tietie.vue?vue&type=style&index=0&id=6585c2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585c2ea",
  null
  
)

export default component.exports